import { render, staticRenderFns } from "./PrintPleadingsDialog.vue?vue&type=template&id=0db0a273&"
import script from "./PrintPleadingsDialog.vue?vue&type=script&lang=js&"
export * from "./PrintPleadingsDialog.vue?vue&type=script&lang=js&"
import style0 from "./PrintPleadingsDialog.vue?vue&type=style&index=0&id=0db0a273&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports